import { useRouteMatch } from "react-router-dom"

export default function useBaseURL() {
  const { url } = useRouteMatch()

  return url.endsWith("/") ? url.slice(0, -1) : url
}
